export default class CancelModel {
    id: number;
    idContrato: number;
    idConvenio: number;
    motivo: number;
    observacao: string;
    dataCancelamento: string | null;
    cancelado: boolean | null;
    associadoNome: string;
    associadoCpf: string;
    categoria: string;

    constructor(
        id: number,
        idContrato: number,
        idConvenio: number,
        motivo: number,
        observacao: string,
        dataCancelamento: string | null,
        cancelado: boolean | null,
        associadoNome: string,
        associadoCpf: string,
        categoria: string
    ) {
        this.id = id;
        this.idContrato = idContrato;
        this.idConvenio = idConvenio;
        this.motivo = motivo;
        this.observacao = observacao;
        this.dataCancelamento = dataCancelamento;
        this.cancelado = cancelado;
        this.associadoNome = associadoNome;
        this.associadoCpf = associadoCpf;
        this.categoria = categoria;
    }

    static fromApiResponse(data: any): CancelModel {
        return new CancelModel(
            data.id,
            data.id_contrato,
            data.id_convenio,
            data.motivo,
            data.observacao,
            data.data_cancelamento,
            data.cancelado,
            data.sec_contrato?.associado?.nome || "",
            data.sec_contrato?.associado?.cpf || "",
            data.sec_contrato?.cad_categoria?.categoria || ""
        );
    }
}
